/*=========================================================================================
  File Name: state.js
  Description: Vuex Store - state
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Cookie from 'js-cookie'
import navbarSearchAndPinList from "@/layouts/components/navbar/navbarSearchAndPinList"
import themeConfig from "@/../themeConfig.js"
import colors from "@/../themeConfig.js"

const userDefaults = {
  uid         : 0,          // From Auth
  displayName : "John Doe", // From Auth
  about       : "Dessert chocolate cake lemon drops jujubes. Biscuit cupcake ice cream bear claw brownie brownie marshmallow.",
  photoURL    : require("@/assets/images/portrait/small/avatar-s-11.jpg"), // From Auth
  status      : "online",
  userRole    : "admin",
}

// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
    AppActiveUser           : userDefaults,
    bodyOverlay             : false,
    isVerticalNavMenuActive : true,
    mainLayoutType          : themeConfig.mainLayoutType || "vertical",
    navbarSearchAndPinList  : navbarSearchAndPinList,
    reduceButton            : themeConfig.sidebarCollapsed,
    verticalNavMenuWidth    : "default",
    verticalNavMenuItemsMin : false,
    scrollY                 : 0,
    starredPages            : navbarSearchAndPinList["pages"].data.filter((page) => page.is_bookmarked),
    theme                   : themeConfig.theme || "light",
    themePrimaryColor       : colors.primary,

    // Can be used to get current window with
    // Note: Above breakpoint state is for internal use of sidebar & navbar component
    windowWidth: null,


  config:{
    logo: '',
    icon: '',
    domainName: '',
    siteName: '',
    type: 0, // 1-客户系统 2-代理系统 3-管理系统\
    siteId: 0,
    files:[
      {fileName: '隐私协议', url: 'http://www.baidu.com'},
      {fileName: '隐私协议', url: 'http://www.baidu.com'},
      {fileName: '隐私协议', url: 'http://www.baidu.com'},
    ],
  },
  "userInfo": {
    "id": 1,
    "username": "admin",
    "phone": "",
    "email": "weideng@alitatech.com",
    "enabled": true,
    "status": null
  },
  userType: 1,
  routers: [], //路由
  addRouters: [], // 菜单
  isAddRoutesDone: false,
  lang:  Cookie.get('language') || 'zh_CN',
  beforePage: 0,
}

export default state
